<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body">
        <h3
          class="uppercase text-center mt-2 title-dashboard"
          style="
            color: #0064b2;
            font-family: 'Times new roman';
            font-weight: bold;
          "
        >
          <!-- {{
            currentUser.roles.includes("SVHTT") || currentUser.roles.includes("PVHTT") ? 
            'CHÀO MỪNG ĐẾN VỚI TRANG QUẢN TRỊ HỆ THỐNG CƠ SỞ DỮ LIỆU DU LỊCH VIỆT NAM AN TOÀN' : 
            'CHÀO MỪNG ĐẾN VỚI TRANG QUẢN TRỊ CHƯƠNG TRÌNH ĐĂNG KÝ, KHAI BÁO AN TOÀN COVID-19'
          }} -->
          CHÀO MỪNG ĐẾN VỚI TRANG QUẢN TRỊ 
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from '../../../service/MethodService';
export default {
  name: "cards",
  methods: {},
  data: function () {
    return {
      show: true,
      currentUser :MethodService.getCurrentUser()
    };
  },
};
</script>

<style scoped>
.fade-enter-active {
  transition: all 0.3s ease;
}
.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.card-body {
  min-height: 86vh;
}
.card {
  position: relative;
}

.card::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  height: 90%;
  background-image: url("~/img/safe-travel.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.3;
  transform: translate(-50%,-50%);
}
.title-dashboard{
  font-size: 25px;
}
@media (max-width: 1366px) {
  .title-dashboard{
    font-size: 20px;
  }  
}
</style>
